/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Fair_Puma_BlowInputs */

const en_happy_fair_puma_blow = /** @type {(inputs: Happy_Fair_Puma_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select`)
};

const de_happy_fair_puma_blow = /** @type {(inputs: Happy_Fair_Puma_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswählen`)
};

/**
* | output |
* | --- |
* | "Select" |
*
* @param {Happy_Fair_Puma_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_fair_puma_blow = /** @type {((inputs?: Happy_Fair_Puma_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Fair_Puma_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_fair_puma_blow(inputs)
	return de_happy_fair_puma_blow(inputs)
});